import * as React from 'react';
import type { IconProps } from '../Icon';
import { Icon } from '../Icon';

/**
 * Element that is used when action Icon is wrapped inside <button>.
 * Attributes of Icon are set in a way in which it conforms to WCAG.
 * @param iconName
 */
export function ButtonIcon({
  iconName
}: Omit<IconProps, 'role' | 'aria-label'>): JSX.Element {
  return <Icon iconName={iconName} aria-label={undefined} />;
}
